import { useEffect, useState } from 'react';

const CRAMPED_WIDTH = 280;

export const useCrampedWidth = (rootRef, compact) => {
  const [cramped, setCramped] = useState(compact);

  useEffect(() => {
    if (compact) {
      setCramped(true);
      return undefined;
    }
    const el = rootRef.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;
    const ro = new ResizeObserver((entries) => {
      const width = entries[0]?.contentRect?.width ?? el.clientWidth;
      setCramped(width < CRAMPED_WIDTH);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [compact, rootRef]);

  return cramped;
};
